<template>
  <v-container class="pa-0" fluid>
    <v-row>
      <banner-toolbar />
    </v-row>
    <v-row justify="center" align="stretch">
      <v-col sm="12" md="8">
        <v-row>
          <v-col>
            <img src="../assets/africa_illlu.png" style="width: 294px;" />
          </v-col>
          <v-col>
            <div class="body-2 secondaryText--text">
              <p>
                  This is to inform you that the call for applications for Open Africa Power 2021 is officially closed. 
                  We are grateful for the enthusiasm and interest towards the programme.
              </p>
              <p>
                  If you did not manage to submit your application in time, we strongly ecourage you to try again next year.
              </p>
              <p>
                  Those who managed to submit an application will receive further information on the unfolding of the selection process next week.
              </p>
              <p>
                Regards,<br />
                The OAP management team
              </p>
            </div>
            <v-btn class="mt-8 half-width" color="accent" @click="onExit">Exit</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import { mapActions } from 'vuex';
import BannerToolbar from "../components/BannerToolbar";

export default {
  name: "EndSubmission",
  components: {
    BannerToolbar
  },
  methods: {
    ...mapActions('auth',{
      logoutUser: "logoutUser"
    }),
    async onExit(){
      await this.logoutUser();
      this.$router.replace({
        name: 'welcome'
      });
    }
  },
}
</script>